import { render, staticRenderFns } from "./qkCourseDetails.vue?vue&type=template&id=2886c8c5&scoped=true"
import script from "./qkCourseDetails.vue?vue&type=script&lang=js"
export * from "./qkCourseDetails.vue?vue&type=script&lang=js"
import style0 from "./qkCourseDetails.vue?vue&type=style&index=0&id=2886c8c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886c8c5",
  null
  
)

export default component.exports